export default __webpack_public_path__ + "static/asphalt-driveway-removal-icon-0d7ea7dca2ffc5806966c0a5270a6e3c.png";